import { useState } from 'react';
import { Link } from 'react-router-dom';
import classes from './Navbar.module.css';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className={classes.navbar}>
            <div className={classes.topBar}>
                <div className={classes.container}>
                    <div className={classes.contactInfo}>
                        <span>📞 +91 8879552122</span>
                        <span>✉️ empireservice022@gmail.com</span>
                        <span>📍 Nalasopara West Vasai-Virar 401203</span>
                    </div>
                    <div className={classes.hours}>
                        <span>🕒 Mon - Sun: 24/7</span>
                    </div>
                </div>
            </div>
            
            <div className={classes.mainNav}>
                <div className={classes.container}>
                    <div className={classes.logo}>
                        <Link to="/" className={classes.logoLink}>Empire Service</Link>
                    </div>
                    
                    <div className={`${classes.navMenu} ${isMenuOpen ? classes.active : ''}`}>
                        <Link to="/" className={classes.navLink}>Home</Link>
                        <Link to="/about" className={classes.navLink}>About us</Link>
                        <Link to="/services" className={classes.navLink}>Services</Link>
                        <Link to="/contact" className={classes.navLink}>Contact</Link>
                       
                        <a href="tel:8879552122" className={classes.callButton}>CALL NOW</a>
                    </div>
                    
                    <div className={classes.hamburger} onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;